import { NavigateFunction } from "react-router";
import { DataPropertyDto, ModelRycApiClient, PropertyDto, PushPropertiesForModelRequest, PushTreeDataToModelRequest } from "../../Api/ApiServer";
import { handleBlobFileUpload } from "../../Uploader/HandleBlobFileUpload";
import LoadPropertiesFully from "../Properties/LoadPropertiesFully";
import { computeRowData } from "../Tree/computeRowData";
import exportFragments from "./exportFragments";
import loadIfcFromUri from "./loadIfcFromUri";
import * as OBC from "@thatopen/components";

export const IfcUploaded = (uri: string, uriForFrags: string, dbModelId: number, components: OBC.Components | null, world: OBC.World | null, api: ModelRycApiClient | null, setLoading: (value: boolean) => void, currentModel: number) => {
    if (!world || !components || !api) return;
    loadIfcFromUri(uri, world, components).then(async (model) => {
        const indexer = components!.get(OBC.IfcRelationsIndexer);
        indexer.process(model).then(() => {
            const inverseAttributes: OBC.InverseAttribute[] = [
                "IsDecomposedBy",
                "ContainsElements",
            ];
            if (model.hasProperties) computeRowData(components!, [model], inverseAttributes).then((data) => {
                console.log('Data:', data, JSON.stringify(data));
                api.pushModelTree(new PushTreeDataToModelRequest({ modelId: dbModelId, ifcTree: JSON.stringify(data) }));

            });
        });
        if (components === null) return;
        const frags = await exportFragments(components, currentModel);
        if (!frags) return;
        await handleBlobFileUpload(new File([new Blob([frags])], "small.frag"), uriForFrags);
        api.completeFragmentsUpload(dbModelId);
        console.log('upload completed');
        LoadPropertiesFully(model, components).then(propsRows => {
            let propsFinal: PropertyDto[] = [];
            propsRows.forEach((row) => {
                row.forEach((dataSingle: any) => {
                    propsFinal.push(new PropertyDto({ data: new DataPropertyDto({ name: dataSingle.data.Name, value: dataSingle.data.Value, propertySetName: dataSingle.data.PropSetName, numberOfDigits: dataSingle.data.NumberOfDigits, unit: dataSingle.data.Unit }), id: dataSingle.id }));
                });
            });
            function chunkArray(array: any[], chunkSize: number) {
                const chunks = [];
                for (let i = 0; i < array.length; i += chunkSize) {
                    chunks.push(array.slice(i, i + chunkSize));
                }
                return chunks;
            }

            const chunks = chunkArray(propsFinal, 8000);
            let promiseChain: any = Promise.resolve();
            console.log('Chunks:', chunks);
            chunks.forEach(chunk => {
                promiseChain = promiseChain.then(() => {
                    return api.pushPropertiesForModel(new PushPropertiesForModelRequest({ modelId: dbModelId, properties: chunk }));
                });
            });

            promiseChain.then(() => {
                setLoading(false);
                window.location.reload(); // Force refresh the page
                // navigate('/logged/viewer/' + dbModelId.toString());
            });
            // console.log('Final propsFinal:', propsFinal);
            // api.pushPropertiesForModel(new PushPropertiesForModelRequest({ modelId: dbModelId, properties: propsFinal })).then(() => {
            //     setLoading(false);
            //     window.location.reload(); // Force refresh the page
            //     // navigate('/logged/viewer/' + dbModelId.toString());

            // })
        })
    });
}